export const getOnlyNotifyRole = role => {
  const roleList = role.split(';');
  return roleList.find(r => r.includes('manager') || r.includes('operator'));
};
